import Echo from 'laravel-echo'
import io from 'socket.io-client'

let url
switch (window.location.hostname) {
    case "local.quinielazo.com":
        url = "http://localhost:4000"
        break;
    case "dev.quinielazo.com":
        url = "https://echo-dev.quinielazo.com"
        break;

    default:
        url = "https://echo.quinielazo.com"
        break;
}
const socketServer = url

const echoClient = new Echo({
    broadcaster: 'socket.io',
    host: socketServer,
    client: io
});

export default {
    setUserToken(token){
        echoClient.connector.options.auth.headers['Authorization'] = `Bearer ${token}`
    },
    getEchoObject() {
        return echoClient;
    },
    channel(channel){
        return echoClient.channel(channel)
    },
    private(channel) {
        return echoClient.private(channel)
    },
    disconnect(){
        return echoClient.disconnect()
    },
    leave(channel){
        return echoClient.leave(channel)
    }
}